export type Shortcuts = Record<string, () => [number, number]>;

export const getPastShortcuts = (): Shortcuts => ({
  "dates.thisMonth": () => {
    const now = new Date();
    const start = new Date(now.getFullYear(), now.getMonth(), 1);
    const end = new Date();
    return [start.getTime(), end.getTime()] as const;
  },
  "dates.today": () => {
    const now = new Date();
    const start = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const end = new Date();
    return [start.getTime(), end.getTime()] as const;
  },
  "dates.pastThreeDays": () => {
    const now = new Date();
    const start = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 3);
    const end = new Date();
    return [start.getTime(), end.getTime()] as const;
  },
  "dates.lastWeek": () => {
    const now = new Date();
    const start = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 7);
    const end = new Date();
    return [start.getTime(), end.getTime()] as const;
  },
  "dates.lastMonth": () => {
    const now = new Date();
    const start = new Date(now.getFullYear(), now.getMonth() - 1, now.getDate());
    const end = new Date();
    return [start.getTime(), end.getTime()] as const;
  },
  "dates.pastThreeMonths": () => {
    const end = new Date();
    const start = new Date();
    start.setMonth(start.getMonth() - 3);
    return [start.getTime(), end.getTime()];
  },
  "dates.pastSixMonths": () => {
    const end = new Date();
    const start = new Date();
    start.setMonth(start.getMonth() - 6);
    return [start.getTime(), end.getTime()];
  },
  "dates.lastYear": () => {
    const end = new Date();
    const start = new Date();
    start.setMonth(start.getMonth() - 12);
    return [start.getTime(), end.getTime()];
  },
});

export const getFutureShortCuts = (): Shortcuts => ({
  "24_hours": () => {
    const end = new Date();
    const start = new Date();
    start.setHours(start.getHours() - 24);
    return [start.getTime(), end.getTime()];
  },
  next_3_days: () => {
    const now = new Date();
    const start = new Date();
    const end = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 3);
    return [start.getTime(), end.getTime()] as const;
  },
  next_week: () => {
    const now = new Date();
    const start = new Date();
    const end = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 7);
    return [start.getTime(), end.getTime()] as const;
  },
  next_month: () => {
    const now = new Date();
    const start = new Date();
    const end = new Date(now.getFullYear(), now.getMonth() + 1, now.getDate());
    return [start.getTime(), end.getTime()] as const;
  },
  next_3_months: () => {
    const start = new Date();
    const end = new Date();
    end.setMonth(end.getMonth() + 3);
    return [start.getTime(), end.getTime()];
  },
  next_6_months: () => {
    const start = new Date();
    const end = new Date();
    end.setMonth(end.getMonth() + 6);
    return [start.getTime(), end.getTime()];
  },
  next_year: () => {
    const start = new Date();
    const end = new Date();
    end.setMonth(end.getMonth() + 12);
    return [start.getTime(), end.getTime()];
  },
});
